var _rect, _rect2, _rect3, _rect4, _rect5, _circle, _circle2, _circle3, _path, _path2, _path3, _circle4, _circle5, _circle6, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChipIcon32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 111,
    height: 111,
    viewBox: "0 0 111 111",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    width: 55,
    height: 111,
    rx: 9,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 84,
    width: 55,
    height: 111,
    rx: 9,
    transform: "rotate(-90 0 84)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 31.7515,
    y: 33.6443,
    width: 45.9195,
    height: 45.9195,
    rx: 8,
    fill: "white",
    stroke: "#1871EF",
    strokeWidth: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 35.1746,
    y: 37.7517,
    width: 39.0738,
    height: 38.3893,
    rx: 8,
    stroke: "#1871EF",
    strokeWidth: 2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 39.6509,
    y: 41.5437,
    width: 30.1208,
    height: 30.1208,
    rx: 9,
    fill: "#1871EF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36.5705,
    cy: 100.758,
    r: 3.44966,
    stroke: "#1871EF",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.4228,
    cy: 99.3894,
    r: 3.44966,
    stroke: "#1871EF",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.906,
    cy: 101.443,
    r: 3.44966,
    stroke: "#1871EF",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.0806 80.5637V94.5973",
    stroke: "#1871EF",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1274 80.5637V87.8306H36.9126V96.9933",
    stroke: "#1871EF",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.349 80.5637V87.8306H74.5637V96.9933",
    stroke: "#1871EF",
    strokeWidth: 2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.44966,
    cy: 4.44966,
    r: 3.44966,
    transform: "matrix(1 0 0 -1 32.1208 17.5839)",
    stroke: "#1871EF",
    strokeWidth: 2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.44966,
    cy: 4.44966,
    r: 3.44966,
    transform: "matrix(1 0 0 -1 51.2886 21.0067)",
    stroke: "#1871EF",
    strokeWidth: 2
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.44966,
    cy: 4.44966,
    r: 3.44966,
    transform: "matrix(1 0 0 -1 70.4563 16.8993)",
    stroke: "#1871EF",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0806 33.3289V21.0067",
    stroke: "#1871EF",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1274 33.3289V26.0619H36.9126V16.8993",
    stroke: "#1871EF",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M66.349 33.3289V26.0619H74.5637V16.8993",
    stroke: "#1871EF",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8657 41.9128C100.771 41.9128 102.315 40.3683 102.315 38.4631C102.315 36.5579 100.771 35.0134 98.8657 35.0134C96.9605 35.0134 95.416 36.5579 95.416 38.4631C95.416 40.3683 96.9605 41.9128 98.8657 41.9128Z",
    stroke: "#1871EF",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3891 61.0805C95.2943 61.0805 96.8388 59.536 96.8388 57.6308C96.8388 55.7256 95.2943 54.1812 93.3891 54.1812C91.4839 54.1812 89.9395 55.7256 89.9395 57.6308C89.9395 59.536 91.4839 61.0805 93.3891 61.0805Z",
    stroke: "#1871EF",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5503 79.5639C101.455 79.5639 103 78.0194 103 76.1142C103 74.209 101.455 72.6646 99.5503 72.6646C97.6451 72.6646 96.1006 74.209 96.1006 76.1142C96.1006 78.0194 97.6451 79.5639 99.5503 79.5639Z",
    stroke: "#1871EF",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6711 57.9731L89.6242 57.9731",
    stroke: "#1871EF",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6711 46.3356L85.938 46.3356L85.9381 38.8054L95.1007 38.8054",
    stroke: "#1871EF",
    strokeWidth: 2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6711 68.2415L85.9381 68.2415L85.9381 75.7717L95.1007 75.7717",
    stroke: "#1871EF",
    strokeWidth: 2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5569 41.9128C8.65173 41.9128 7.10726 40.3683 7.10726 38.4631C7.10726 36.5579 8.65173 35.0134 10.5569 35.0134C12.4621 35.0134 14.0066 36.5579 14.0066 38.4631C14.0066 40.3683 12.4621 41.9128 10.5569 41.9128Z",
    stroke: "#1871EF",
    strokeWidth: 2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0335 61.0805C14.1283 61.0805 12.5838 59.536 12.5838 57.6308C12.5838 55.7256 14.1283 54.1812 16.0335 54.1812C17.9387 54.1812 19.4832 55.7256 19.4832 57.6308C19.4832 59.536 17.9387 61.0805 16.0335 61.0805Z",
    stroke: "#1871EF",
    strokeWidth: 2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M9.87236 79.5639C7.96716 79.5639 6.42269 78.0194 6.42269 76.1142C6.42269 74.209 7.96716 72.6646 9.87236 72.6646C11.7776 72.6646 13.322 74.209 13.322 76.1142C13.322 78.0194 11.7776 79.5639 9.87236 79.5639Z",
    stroke: "#1871EF",
    strokeWidth: 2
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7517 57.9731L19.7987 57.9731",
    stroke: "#1871EF",
    strokeWidth: 2
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7517 46.3356L23.4848 46.3356L23.4848 38.8054L14.3222 38.8054",
    stroke: "#1871EF",
    strokeWidth: 2
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7517 68.2415L23.4848 68.2415L23.4848 75.7717L14.3222 75.7717",
    stroke: "#1871EF",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChipIcon32);
export default __webpack_public_path__ + "static/media/chip-icon3-2.213722cf9020cad00139f0887e3f01e3.svg";
export { ForwardRef as ReactComponent };